/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Component } from '@angular/core';
import { CmsOrderDetailOverviewComponent, TranslationService } from '@spartacus/core';
import { OrderDetailsService, OrderOverviewComponent } from '@spartacus/order/components';
import { CmsComponentData } from '@spartacus/storefront';
import { UdxOrderOverviewComponent } from '../order-overview/udx-order-overview.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'udx-cx-order-details-shipping',
    templateUrl: './udx-order-detail-shipping.component.html',
    imports: [UdxOrderOverviewComponent, AsyncPipe]
})
export class UdxOrderDetailShippingComponent extends OrderOverviewComponent {
  constructor(
    translation: TranslationService,
    orderDetailsService: OrderDetailsService,
    component: CmsComponentData<CmsOrderDetailOverviewComponent>
  ) {
    super(translation, orderDetailsService, component);
  }
}

